import axios, { AxiosRequestConfig } from 'axios';

import { topchefConfiguration } from './topchef-configuration.js'
import { Administrator, Lead, LeadCreation, LeadWithBill, LocHallBill, PublicLead } from './topchef.types.js'
import { apiRequest, getErrorMessage, apiSharedConfig } from './topchef.utils.js'
import { extractFileNameFromHeader, startFileDownload } from './download.js'


const getLoggedIAdmin = (): Promise<Administrator> =>
  apiRequest('GET', `${topchefConfiguration.apiUrl}/api/backoffice/me`);


const loadAllLeads = (): Promise<PublicLead[]> =>
  apiRequest('GET', `${topchefConfiguration.apiUrl}/api/backoffice/leads/all`);


const loadLeadDetails = (leadId: string): Promise<Lead> =>
  apiRequest('GET', `${topchefConfiguration.apiUrl}/api/backoffice/leads/all/${leadId}`);


const loadLeadsToValidate = (): Promise<PublicLead[]> =>
  apiRequest('GET', `${topchefConfiguration.apiUrl}/api/backoffice/leads/to-validate`);


const loadLeadToValidate = (leadId: string): Promise<Lead> =>
  apiRequest('GET', `${topchefConfiguration.apiUrl}/api/backoffice/leads/to-validate/${leadId}`);


const validateLead = (leadId: string, leadCreation: LeadCreation): Promise<void> =>
  apiRequest('PUT', `${topchefConfiguration.apiUrl}/api/backoffice/leads/to-validate/${leadId}/validate`, {...leadCreation});


const refuseLead = (leadId: string): Promise<void> =>
  apiRequest('PUT', `${topchefConfiguration.apiUrl}/api/backoffice/leads/to-validate/${leadId}/deny`, {});


const loadBillsToValidate = (): Promise<Lead[]> =>
  apiRequest('GET', `${topchefConfiguration.apiUrl}/api/backoffice/leads/bills-to-validate`);


const loadLeadWithBillToValidate = (leadId: string): Promise<LeadWithBill> =>
  apiRequest('GET', `${topchefConfiguration.apiUrl}/api/backoffice/leads/bills-to-validate/${leadId}`);


async function downloadBill(leadId: string): Promise<void> {
  
  const downloadConfig: AxiosRequestConfig = {
    ...apiSharedConfig,
    responseType: 'blob',
  };

  return await axios.get(topchefConfiguration.apiUrl + `/api/backoffice/leads/bills-to-validate/${leadId}/bill`, downloadConfig)
  .then((response) => {
    const filename = extractFileNameFromHeader(response.headers['content-disposition']) as string;
    startFileDownload(filename, response.data, response.headers['content-type']);
  })
  .catch( (error) => {
    const errorMessage:string = getErrorMessage(error);
    return Promise.reject(new Error(errorMessage));
  });
}


const validateBill = (leadId: string, bill: LocHallBill): Promise<void> =>
  apiRequest('PUT', `${topchefConfiguration.apiUrl}/api/backoffice/leads/bills-to-validate/${leadId}/validate`, {...bill});


const features = {
  getLoggedIAdmin,
  loadLeadsToValidate,
  loadLeadToValidate,
  validateLead,
  refuseLead,
  loadBillsToValidate,
  loadLeadWithBillToValidate,
  downloadBill,
  validateBill,
  loadAllLeads,
  loadLeadDetails
};

export default features;